export default __webpack_public_path__ + "static/media/advocate-img6.89057adf.png";